<template>
  <section id="mindfulness-main" class="open-salud-about-mindfulness">
    <v-row class="row container-assistance">
      <v-col sm="6" class="main-container-text px-lg-16 my-auto">
        <h3 class="title">{{ title }}</h3>
        <h5 class="subtitle">{{ subtitle }}</h5>
        <h7 class="thirdtitle">{{ thirdtitle }}</h7>

        <v-col sm="12" class="pl-0">
          <v-row class="mt-3 button-floating">
            <base-button white shadow class="btn1"
              @click="getWellness()">
              {{ button_text2 }}
            </base-button>
          </v-row>
        </v-col>
      </v-col>
      <v-col sm="6" class="col-img d-flex flex-row justify-center col-image">
      </v-col>
    </v-row>
    <div
      class="learn-more"
      @click="$helpers.goToSection('primesalud-price-cards')"
      v-if="!$store.getters['session/isLogged']"
    >
      <span>{{ $t("learn-more-btn") }}</span>
    </div>
  </section>
</template>

<script>
import es from '@/lang/es/public/views/mindfulness.json'
import en from '@/lang/en/public/views/mindfulness.json'
import opensaludprimeMixin from '@/mixins/opensaludprime.mixin'

export default {
  mixins: [opensaludprimeMixin],
  name: 'mindfulness-main-block',
  i18n: {
    messages: {
      es,
      en,
      mx: es
    }
  },
  props: {
    title: {
      type: String,
      default () {
        return this.$t('header-title')
      }
    },
    subtitle: {
      type: String,
      default () {
        return this.$t('upper-header-subtitle')
      }
    },
    thirdtitle: {
      type: String,
      default () {
        return this.$t('upper-header-thirdtitle')
      }
    },
    button_text: {
      type: String,
      default () {
        return this.$t('hire-now-with-price')
      }
    },
    button_text2: {
      type: String,
      default () {
        return this.$t('hire-now-with-price-2')
      }
    },
    label_text: {
      type: String,
      default () {
        return this.$t('learn-more-btn')
      }
    }
  },
  methods: {
    buy () {
      this.$helpers.goToWebApp(
        '#dlgRegisterPatient?returnUrl=/HomePaciente#/profile/addsubscription/opensaludpass'
      )
    }
  }
}
</script>

<style lang='scss'>
@import '../../../static-appopensalud/css/public/layout.scss';
.title{
  margin-bottom: 1.5rem !important;
  @media (max-height:750px)  {
    font-size: 2rem !important;
    line-height: 2.5rem !important;
  }
}
.subtitle{
  margin-bottom: 1.5rem !important;
}
.thirdtitle{
  margin-bottom: 1.5rem !important;
  color: #3238c4;
}
.btn1 {
  max-width: 22em;
  @include desktop(){
    width: 12rem;
  }
}

.row {
  margin: 0;
}

[class*="col-"] {
  padding: 0px;
}

section.open-salud-about-mindfulness {
  background-color: #e4e4e4;
  font-family: "Space Grotesk", sans-serif;
  text-align: left;
  position:relative;
}

.open-salud-about-mindfulness p {
  color: black;
  line-height: 1.2;
  font-weight: 400;
  font-size: 1rem;
}

.open-salud-about-mindfulness h3 {
  font-size: 4rem;
  line-height: 4.5rem;
  margin-top: 1rem;
  font-weight: 100;
}
.open-salud-about-mindfulness .main-container-text {
  @include container-padding;
}
.open-salud-about-mindfulness .container-assistance {
  margin: 0px;
  min-height: 100vh;

  @include media(mobile, tablets) {
    flex-direction: column-reverse;
  }
}

.open-salud-about-mindfulness .v-btn {
  color: #3238c4;
  border-color: #3238c4;
  font-size: 0.8rem;
  box-shadow: 13px 12px 39px -5px #87888a;
  background-color: #fff;
}

#mindfulness-main .col-img {
      @include mobile() {
      background-image: url(/static-appopensalud/img/bgs/opt/saludmental1.jpg),
      linear-gradient(273deg, #ffffff96, transparent) !important;
        background-position-x: right !important;
        background-position-y: initial !important;

    }
  background-image: url("/static-appopensalud/img/bgs/opt/saludmental1.jpg");
  background-size: cover;
  background-position: center;
  min-height: 50vh;
}

.open-salud-about-mindfulness .g-image {
  width: 100vw;
}

.open-salud-about-mindfulness .v-list.v-sheet.theme--light {
  background-color: transparent;
}
.open-salud-about-mindfulness .v-list-item__title {
  white-space: normal;
}

.open-salud-about-mindfulness .v-list-item.v-list-item--link.theme--light {
  padding: 0;
  width: 25rem;
}
.open-salud-about-mindfulness .floating-container {
  position: relative;
}
.open-salud-about-mindfulness .floating-text {
  color: #3238c4;
  border-right: 1px solid #3238c4;
  padding: 0px 0 0rem 0rem;
  cursor: pointer;
  height: 7.5rem;
  position: absolute;
  left: 90%;
}

.open-salud-about-mindfulness .floating-label {
  transform: rotate(-90deg);
  color: #3238c4;
  font-family: "Space Grotesk", sans-serif;
  right: -2%;
  position: absolute;
  top: 20%;
  margin-top: 4rem;
  font-size: 0.8rem;
}


@media (max-width: 1263px) {
  .open-salud-about-mindfulness .floating-text {
    bottom: 0;
  }

  .open-salud-about-mindfulness .floating-label {
    right: 0;
    margin-top: -9%;
  }
  .open-salud-about-mindfulness .container-assistance {
    display: flex;
  }
  .open-salud-about-mindfulness .main-container-text,
  .open-salud-about-mindfulness .col-img {
    max-width: 50%;
  }

  .open-salud-about-mindfulness .button-floating {
    margin-bottom: 1rem;
    color: #3238c4;
    display: flex;
    justify-content: initial;
    align-items: baseline;
  }
    .open-salud-about-mindfulness h3 {
      margin-top: 3rem;
    }
}
@media (max-width: 1024px) {
  .open-salud-about-mindfulness .main-container-text,
  .open-salud-about-mindfulness .col-img {
    max-width: none;
  }
}
@media (max-width: 600px) {
  .open-salud-about-mindfulness .floating-text {
    left: 85%;
  }

  .open-salud-about-mindfulness .floating-label {
    margin-top: -11%;
  }
  .open-salud-about-mindfulness .main-container-text {
    padding: 2rem;
  }
  .open-salud-about-mindfulness h3 {
      width: 100%;
      margin-left: 0;
      margin-top: 1rem;
      font-size: 2rem;
      line-height: 2.5rem;
    }
  .open-salud-about-mindfulness .v-list-item.v-list-item--link.theme--light {
    width: 70vw;
  }
  .open-salud-about-mindfulness.floating-text,
  .open-salud-about-mindfulness.button-floating {
    margin-bottom: 1rem;
    color: #3238c4;
    display: flex;
    justify-content: space-evenly;
    align-items: baseline;
  }

  .open-salud-about-mindfulness.section-icons {
    margin-top: 35rem;
  }
}

.learn-more {
  position: absolute;
  bottom: 0;
  color: #3238c4;
  border-left: 1px solid #3238c4;
  padding: 0 0 2rem 0.5rem;
  cursor: pointer;
  font-size: 0.8rem;
  transition-duration: 0.5s;

  &:hover {
    font-size: 1rem;
    transition-duration: 0.5s;
  }

  span {
    writing-mode: tb-rl;
    transform: rotate(-180deg);
  }


  @include desktop {
    left: 45vw;
  }

  @include tablets {
    right: 7rem;
    left: initial;
  }

  @include mobile {
    display: none;
  }
}

.main-container-text  {
  @include desktop {
    padding-top: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/MindfulnessMainBlock.vue